import { render } from "./FlagIcon.vue?vue&type=template&id=21291af8"
const script = {}
script.render = render

export default script